export const auth = {
  authHomeTitle: '시작합시다',
  authHomeButtonBranded: '이메일로 계속',
  authHomeButtonApple: 'Apple 계정으로 계속',
  authHomeButtonGoogle: 'Google 계정으로 계속',
  authHomeButtonFacebook: 'Facebook 계정으로 계속',
  authHomeButtonLinkedin: 'LinkedIn 으로 계속하기',
  authStartTitle: '로그인 또는 가입',
  authStartInputTitle: '이메일',
  authStartInputTitleError: '유효한 이메일을 입력하세요!',
  authStartInputPasswordError: '유효한 비밀번호를 입력하세요!',
  authWhoops: '앗!',
  authStartConfirmButton: '계속',
  authRegisteredTitle: '다시 오신 것을 환영합니다!',
  authStartPlaceholderTitle: '이메일',
  authRegisteredInputTitle: '비밀번호',
  authRegisteredForgotPassword: '비밀번호를 잊으셨나요',
  authAlertIncorrectPassword: '이메일이나 비밀번호가 잘못되었습니다',
  authAlertRequiredPassword: '유효한 비밀번호를 입력하세요',
  authFinishSignUpTitle: '가입 완료',
  authFinishSignUpEmailInputTitle: '이메일',
  authFinishSignUpFirstNameInputTitle: '이름',
  authFinishSignUpLastNameInputTitle: '성',
  authFinishSignUpPasswordInputTitle: '비밀번호',
  authFinishSignUpTipContent:
    '<ul class="text-14 pl-4 text-black"><li class="-ml-4 list-none">다음을 권장합니다:</li><li class="list-disc">최소 8자 이상</li><li class="list-disc">숫자 1개 포함</li><li class="list-disc">특수 기호 1개 포함</li></ul>',
  authFinishSignUpPrivacyAndTerms: {
    text1: '가입을 클릭함으로써 당신은 다음에 동의합니다:',
    privacyPolicy: '개인정보 처리방침',
    text2: '그리고',
    termsOfUse: '이용 약관'
  },
  authFinishSignUpConfirmButton: '가입',
  authFinishSignUpErrorFirstName: '이름을 입력하세요!',
  authFinishSignUpErrorLastName: '성을 입력하세요!',
  authFinishSignUpErrorPassword: '비밀번호가 너무 짧습니다!',
  authEmailConfirmationTitle: '메일함을 확인하세요',
  authEmailConfirmationContent:
    '이메일 주소를 확인하려면 확인 이메일을 보냈습니다. 받은 편지함에 찾을 수 없는 경우 스팸함을 확인하세요.',
  authEmailConfirmationConfirmButton: '로그인으로 돌아가기',
  authAlertEmailConfirmation: '이메일 확인을 위해 받은 편지함을 확인하세요!',
  authResetPasswordTitle: '메일함을 확인하세요',
  authResetPasswordDescription: '비밀번호 재설정 링크를 이메일로 보냈습니다. 받은 편지함에 찾을 수 없는 경우 스팸함을 확인하세요.',
  authResetPasswordButton: '로그인으로 돌아가기',
  authNewPasswordTitle: '새로운 비밀번호 입력',
  authNewPasswordInputTitle: '새로운 비밀번호',
  authNewPasswordButton: '비밀번호 재설정',
  authNewPasswordAlertValidation: '비밀번호가 충분히 강력하지 않습니다',
  authPasswordChangeSuccessTitle: '비밀번호 변경됨!',
  authPasswordChangeSuccessContent: '비밀번호가 성공적으로 변경되었습니다!',
  authPasswordChangeSuccessButton: '로그인으로 돌아가기',
  authPasswordChangeErrorTitle: '오류!',
  authPasswordChangeErrorContent: '비밀번호 재설정 중에 오류가 발생했습니다! 나중에 다시 시도하세요.',
  authPasswordChangeErrorButton: '로그인으로 돌아가기',
  authInvitationTitle: '비밀번호 설정',
  authInvitationInputTitle: '비밀번호',
  authInvitationButton: '비밀번호 설정',
  authEmailAddressConfirmed: '이메일 주소 확인됨!'
}
